import talent from '../views/talent'

export default {
  path: '/talent',
  component: talent,
  redirect: '/talent/talentWork',
  name: 'Talent',
  meta: {
    title: '库存管理'
  },
  children: [
    {
      path: '/talent/talentWork',
      component: () => import('../views/talent/TalentWork'),
      name: 'TalentWork',
      meta: {
        title: '库存查询'
      }
    },
    {
      path: '/talent/talentPool',
      component: () => import('../views/talent/TalentPool'),
      name: 'TalentPool',
      meta: {
        title: '库存变更记录'
      }
    },
    {
      path: '/talent/antStar',
      component: () => import('../views/talent/AntStar'),
      name: 'AntStar',
      meta: {
        title: '要货记录'
      }
    },
    {
      path: '/talent/training',
      component: () => import('../views/talent/Training'),
      name: 'Training',
      meta: {
        title: '要货申请'
      }
    },
    {
      path: '/talent/talentCenter',
      component: () => import('../views/talent/TalentCenter'),
      name: 'TalentCenter',
      meta: {
        title: '经销商要货'
      }
    }
  ]

}
